export enum EnStationTypes {
  Restaurant = 0,
  Hotel = 1,
  Retail = 2,
}
